/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const PenSquareIconConfig = {
  name: 'PenSquareIcon',
  height: 512,
  width: 448,
  svgPath: 'M400 480H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zM238.1 177.9L102.4 313.6l-6.3 57.1c-.8 7.6 5.6 14.1 13.3 13.3l57.1-6.3L302.2 242c2.3-2.3 2.3-6.1 0-8.5L246.7 178c-2.5-2.4-6.3-2.4-8.6-.1zM345 165.1L314.9 135c-9.4-9.4-24.6-9.4-33.9 0l-23.1 23.1c-2.3 2.3-2.3 6.1 0 8.5l55.5 55.5c2.3 2.3 6.1 2.3 8.5 0L345 199c9.3-9.3 9.3-24.5 0-33.9z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(PenSquareIconConfig);
//# sourceMappingURL=pen-square-icon.js.map